import object from '@mailobj-browser/front/js/utils/object.js'
import resolvable from '@mailobj-browser/front/js/utils/resolvable.js'
import globals from '#utilities/js/ea/globals.js'
import href from '#utilities/js/ea/href.js'

import defer from '../network/defer.js'

export default (name, block, params) => {
  const intentName = `custom.actions.intent.${name}`
  return object(null, {
    action: intentName,
    task: async (intent) => {
      console.log(`Managing ${intentName}`)
      const [promise, { resolve, reject }] = resolvable()
  
      const url = href(block, params)
      defer(() => {
        globals.ea_link_direct(url, '', resolve)
      })
  
      return promise
    }
  })
}

